import { Tooltip } from "@mui/material";
import {
  DropdownsContext,
  DropdownsProvider,
} from "../../../../contexts/DropdownsContext";
import "./QuoteVendorList.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Expandable } from "../../../../components/Expandable/Expandable";
import { Sorting } from "../../../../components/Lists/Sorting";
import { Radios } from "../../../../components/RadioGroup/Radios";
import { Tag } from "../../../../components/Tags/Tag";
import {
  getVendorQuoteList,
  updateFromQuote,
} from "../../Services/QuoteService";
import Skeleton from "react-loading-skeleton";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import { QuoteOrderContext } from "../../context/QuoteOrderContext";
import { formatCurrency } from "../../../../utils/utils";
import Input from "../../../../components/Inputs/Input";
import BasicDatePicker from "../../../../components/Datepicker/Datepicker";
import Dropdowns from "../../../../components/Dropdowns/Dropdowns";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { LABELS } from "../../../../globals/globals";

const tagsMapper = {
  success: "Quoted",
  info: "Partially Quoted",
  warning: "Pending",
  issued: "Expired",
};
const dropdownIds = [74];
const dropdownNames = {
  74: "currency_id",
};
const ribbonColors = ["var(--blue-300)", "var(--green-350)", "#f7931e"];
const defaultColor = "var(--blue-300)";
const ribbon = [{ when: true, label: LABELS.DRAFT }];
export const QuoteVendorList = ({ prn, quote, cant, onQuoteUpdate }) => {
  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const listRef = useRef(null);
  const [hasVendorOrdered, setHasVendorOrdered] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [loadingQuotes, setLoadingQuotes] = useState(false);
  const [vendorSelected, setVendorSelected] = useState(null);
  const {
    setQuoteToOrderList,
    quoteToOrderList,
    saveDraft,
    removeDraft,
    isDetailOnDraft,
    updateDraft,
    drafts,updateInfoList, setUpdateInfoList
  } = useContext(QuoteOrderContext);
  const [displayForm, setDisplayForm] = useState(false);
  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const didMount = useRef(false);
  const {
    dropdownsData,
    setDropdownsData,
    setDropdownIds,
    dropdownDefaultOptions,
  } = useContext(DropdownsContext);
  useEffect(() => {
    setDropdownIds(dropdownIds);
  }, []);
  const getSortingOrder = (order) => {
    // setSortingOrder(order);
  };
  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) {
      setDisplayForm(true);
    }
  }, [dropdownsData]);
  const switchedTagsMapper = Object.fromEntries(
    Object.entries(tagsMapper).map(([key, value]) => [value, key])
  );
  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      // if (!setLoadingPartsReq) requestNextPage();
    }
  };
  useEffect(() => {
    if (!quoteToOrderList || quoteToOrderList.length === 0) {
      setVendorSelected(null);
    }
  }, [quoteToOrderList]);
  const onChangeRadio = (value) => {
    if(hasVendorOrdered){
      return;
    }
    const selectedItem = dataList.find((item) => item.id === Number(value));
    if (selectedItem?.status === "Pending") {
      warningMsg(
        "Warning",
        "This vendor has not provided a quote yet. Please contact them for more information."
      );
      return;
    }
    if (!selectedItem) return;

    selectedItem.location_id = prn.location_id;
    setVendorSelected(selectedItem);

    setQuoteToOrderList((prev = []) => {
      const existsIndex = prev.findIndex(
        (item) =>
          item.quote_request_id === selectedItem.quote_request_id &&
          item.part_request_id === selectedItem.part_request_id && item.part_id === selectedItem.part_id
      );

      if (existsIndex !== -1) {
        const updated = [...prev];
        updated[existsIndex] = selectedItem;
        return updated;
      } else {
        return [...prev, selectedItem];
      }
    });
  };

  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
    if (quote) {
      setLoadingList(true);
      getVendorQuoteList(quote.id, prn.part_request_id, prn.part_id)
        .then((response) => {
          setLoadingList(false);
          if (response.data.responseCode === 200) {
            const inventoryArray = response.data.load.map((item) => {
              let draftVales;
              if (isDetailOnDraft(item.id)) {
                draftVales = drafts[item.id];
              }
              if(item.status === "Ordered" && !hasVendorOrdered) {
                setHasVendorOrdered(true);
              }
              return {
                ...item,
                formated_sub_total: formatCurrency(
                  item.unit_cost * cant,
                  item.currency
                ),
                formated_total_cost: formatCurrency(
                  item.unit_cost * cant -
                    item.discount_applied +
                    item.tax_included,
                  item.currency
                ),
                total_cost:
                  item.unit_cost * cant -
                  item.discount_applied +
                  item.tax_included,
                location_id: prn.location_id,
                part_number: prn.part_number,
                part_description: prn.part_description,
                uom_abrevation: prn.uom_abrevation,
                company_name: prn.company_name,
                uom_id: prn.uom_id,
                quantity_required: prn.quantity_required,
                work_package_number: prn.work_package_number,
                work_package_id: prn.work_package_id,
                reference_id: prn.reference_id,
                reference_number: prn.reference_number,
                reference_type: prn.reference_type,
                tail_number: prn.tail_number,
                response_date: item.response_date
                  ? item.response_date.split("T")[0]
                  : "--",
                formated_unit_cost: formatCurrency(
                  item.unit_cost,
                  item.currency
                ),
                formated_discount_applied: formatCurrency(
                  item.discount_applied,
                  item.currency
                ),
                formated_tax_included: formatCurrency(
                  item.tax_included,
                  item.currency
                ),
                ...draftVales,
              };
            });

            setDataList(inventoryArray);
            const existing = quoteToOrderList?.find(
              (q) =>
                q.quote_request_id === quote.id &&
                q.part_request_id === prn.part_request_id
            );

            if (existing) {
              const match = inventoryArray.find(
                (item) => item.id === existing.id
              );
              if (match) {
                setVendorSelected(match);
              }
            }
          }
        })
        .catch((error) => {
          setLoadingList(false);
        });
    }
  }, []);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    if (quote) {
      getVendorQuoteList(quote.id, prn.part_request_id, prn.part_id)
        .then((response) => {
          if (response.data.responseCode === 200) {
            const inventoryArray = response.data.load.map((item) => {
              let draftVales;
              if (isDetailOnDraft(item.id)) {
                draftVales = drafts[item.id];
              }
                  if(item.status === "Ordered" && !hasVendorOrdered) {
                setHasVendorOrdered(true);
              }
              return {
                ...item,
                formated_sub_total: formatCurrency(
                  item.unit_cost * cant,
                  item.currency
                ),
                formated_total_cost: formatCurrency(
                  item.unit_cost * cant -
                    item.discount_applied +
                    item.tax_included,
                  item.currency
                ),
                total_cost:
                  item.unit_cost * cant -
                  item.discount_applied +
                  item.tax_included,
                location_id: prn.location_id,
                part_number: prn.part_number,
                part_description: prn.part_description,
                uom_abrevation: prn.uom_abrevation,
                company_name: prn.company_name,
                uom_id: prn.uom_id,
                quantity_required: prn.quantity_required,
                work_package_number: prn.work_package_number,
                work_package_id: prn.work_package_id,
                reference_id: prn.reference_id,
                reference_number: prn.reference_number,
                reference_type: prn.reference_type,
                tail_number: prn.tail_number,
                response_date: item.response_date
                  ? item.response_date.split("T")[0]
                  : "--",
                formated_unit_cost: formatCurrency(
                  item.unit_cost,
                  item.currency
                ),
                formated_discount_applied: formatCurrency(
                  item.discount_applied,
                  item.currency
                ),
                formated_tax_included: formatCurrency(
                  item.tax_included,
                  item.currency
                ),
                ...draftVales,
              };
            });

            setDataList(inventoryArray);
            const existing = quoteToOrderList?.find(
              (q) =>
                q.quote_request_id === quote.id &&
                q.part_request_id === prn.part_request_id
            );

            if (existing) {
              const match = inventoryArray.find(
                (item) => item.id === existing.id
              );
              if (match) {
                setVendorSelected(match);
              }
            }
          }
        })
        .catch((error) => {});
    }
  }, [updateInfoList]);

  const enableEdition = (item, isOnEdition) => {
    const idx = dataList.findIndex((i) => i.id === item.id);
    if (idx === -1) return;
    if (isOnEdition) {
      dataList[idx].isOnEdition = true;
      saveDraft(item.id, "quote", item);
      setDataList([...dataList]);
    } else {
      updateQuoteDetails(item);
    }
  };

  const updateQuoteDetails = (item) => {
    const result = [];
    const updatedValues = {
      responseDate: new Date(item.response_date),
      unitCost: parseFloat(item.unit_cost),
      taxIncluded: parseFloat(item.tax_included),
      leadDays: item.lead_days,
      unitCostdiscountApplied: parseFloat(item.discount_applied),
      currencyId: parseInt(item.currency_id),
    };
    result.push({
      id: parseInt(item.id),
      ...updatedValues,
    });
    updateFromQuote(result)
      .then((res) => {
        if (res.data.responseCode === 200) {
          successMsg("Quote was updated successfully.");
          removeDraft(item.id, "quote");
          setUpdateInfoList(new Date().getTime());
          onQuoteUpdate();
        }
      })
      .catch((err) => {});
  };

  const changeValue = (e, item) => {
    const { name, value, completeValue } = e.target;
    const idx = dataList.findIndex((i) => i.id === item.id);
    if (idx === -1) return;
    dataList[idx][name] = value;
    const subTotal = dataList[idx].unit_cost * cant;
    const discount = dataList[idx].discount_applied || 0;
    const taxIncluded = dataList[idx].tax_included || 0;
    const totalCost = subTotal - parseInt(discount) + parseInt(taxIncluded);
    dataList[idx].sub_total = subTotal;
    dataList[idx].total_cost_pn = totalCost;
    updateDraft(item.id, "quote", dataList[idx]);
    setDataList([...dataList]);
  };
  const changeValueDate = (newValue, name, item) => {
    const completeValue = newValue?.format("YYYY-MM-DD");
    const idx = dataList.findIndex((i) => i.id === item.id);
    if (idx === -1) return;
    dataList[idx][name] = completeValue;
    setDataList([...dataList]);
  };
  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };
  const handleDropdownValue = (value, name, data, item) => {
    changeValue(
      { target: { name, value: value[data], completeValue: value } },
      item
    );
  };
  return (
    <div className="quote-tracking-list-vendor-container">
      <div className="sorting-header">
        <div className="sorting-free-slot"> </div>
        <Sorting
          onOrderChange={getSortingOrder}
          ignoreProperties={true}
          displayButton={false}
        showHeaderOrder={true}
          initialSort="date_request_required"
          properties={{
            id: "Vendor",
            score: { label: "Score", align: "center" },
            required: { label: "Currency", align: "center" },
            delivery_date: "Response Date",
            lead_days: { label: "Lead Days", align: "center" },
            remaining: { label: "Unit Cost", align: "center" },
            pendingOrder: { label: "Subtotal", align: "center" },
            Discount: { label: "Discount Applied", align: "center" },
            taxIncluded: { label: "Tax Included", align: "center" },
            totalCost: { label: "Total Cost", align: "center" },
            status: { label: "Status", align: "center" },
          }}
        ></Sorting>
      </div>
      <div className="quote-list" ref={listRef} onScroll={handleScroll}>
        {loadingList ? (
          Array.from({ length: 7 }).map((_, idx) => (
            <div key={idx} className="item-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width={40}
              />
              <div className="item-skeleton-content">
                <Skeleton height={20} width="80%" />
              </div>
              <Skeleton height={30} width="7rem" />
            </div>
          ))
        ) : dataList.length === 0 ? (
          <ResultsNotFound />
        ) : (
          <Radios
            items={dataList.map((item, idx) => ({
              value: item.id,
              item, // lo pasamos tal cual para usarlo luego
            }))}
            name="myRadio"
            value={vendorSelected?.id ?? ""}
            onChange={(value) => onChangeRadio(value)}
            direction="column"
            customRender={(radioItem, isSelected) =>
              !radioItem.item.isOnEdition &&
              !isDetailOnDraft(radioItem.item.id) ? (
                <div className={`item-quote-vendor-container ${hasVendorOrdered && radioItem.item.status != "Ordered" ? 'disabled-item' : ''}`} key={radioItem.item.id}>
                  {[
                    "vendor_name",
                    "score",
                    "currency",
                    "response_date",
                    "lead_days",
                    "formated_unit_cost",
                    "formated_sub_total",
                    "formated_discount_applied",
                    "formated_tax_included",
                    "formated_total_cost",
                  ].map((label) => (
                    <div
                      className={`property ${
                        label === "formated_totalCost" ||
                        label === "currency" ||
                        label === "formated_unit_cost" ||
                        label === "formated_total_cost" ||
                        label == "formated_sub_total" ||
                        label == "formated_discount_applied" ||
                        label == "formated_tax_included" ||
                        label === "lead_days"
                          ? "centerItem"
                          : ""
                      }`}
                      key={label}
                    >
                      <Tooltip
                        title={
                          tooltips[`${radioItem.item.id}-${label}`]
                            ? radioItem.item[label]
                            : ""
                        }
                        arrow
                      >
                        {label == "formated_total_cost" ||
                        label == "lead_days" ? (
                          <p
                            className="bold-font"
                            ref={(el) => {
                              if (el) {
                                propertyRefs.current[
                                  `${radioItem.item.id}-${label}`
                                ] = el;
                              }
                            }}
                          >
                            {radioItem.item[label] || "--"}
                          </p>
                        ) : label == "vendor_name" ? (
                          <p
                            className="light-font"
                            ref={(el) => {
                              if (el) {
                                propertyRefs.current[
                                  `${radioItem.item.id}-${label}`
                                ] = el;
                              }
                            }}
                          >
                            {radioItem.item.vendor_id} - {radioItem.item[label]}
                          </p>
                        ) : label == "score" ? (
                          <div className="score-container">
                            <i className="icon-favorite"> </i>
                            <p
                              className="light-font"
                              ref={(el) => {
                                if (el) {
                                  propertyRefs.current[
                                    `${radioItem.item.id}-${label}`
                                  ] = el;
                                }
                              }}
                            >
                              {radioItem.item[label] || "--"}
                            </p>
                          </div>
                        ) : (
                          <p
                            className="light-font"
                            ref={(el) => {
                              if (el) {
                                propertyRefs.current[
                                  `${radioItem.item.id}-${label}`
                                ] = el;
                              }
                            }}
                          >
                            {radioItem.item[label] || "--"}
                          </p>
                        )}
                      </Tooltip>
                    </div>
                  ))}
                  <div className="tag-status-vendor">
                    <button
                      className={`button-vendor-action ${hasVendorOrdered ? 'disabled' : ''}`}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        enableEdition(radioItem.item, true);
                      }}
                    >
                      <i className="icon-edit"></i>
                    </button>

                    <Tag
                      style={{ width: "9vw" }}
                      tag={radioItem.item.status}
                      type={switchedTagsMapper[radioItem.item.status]}
                    ></Tag>
                  </div>
                </div>
              ) : (
                <div
                  className="item-quote-vendor-container"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }}
                >
                  {ribbon && isDetailOnDraft(radioItem.item.id) && (
                    <div className="ribbons-container">
                      {ribbon
                        .filter?.((r) => r.when)
                        ?.map?.((r, i, a) => (
                          <span
                            className="ribbon"
                            key={r.label}
                            style={{
                              backgroundColor:
                                r.color ??
                                ribbonColors[i % ribbonColors.length] ??
                                defaultColor,
                              left:
                                i < a.length - 1
                                  ? `${-0.5 * (ribbon.length - 1 - i)}rem`
                                  : "",
                            }}
                          >
                            {r.label}
                          </span>
                        ))}
                    </div>
                  )}
                  {["vendor_name", "score"].map((label) => (
                    <div className={`property`} key={label}>
                      <Tooltip
                        title={
                          tooltips[`${radioItem.item.id}-${label}`]
                            ? radioItem.item[label]
                            : ""
                        }
                        arrow
                      >
                        {label == "formated_total_cost" ||
                        label == "lead_days" ? (
                          <p
                            className="bold-font"
                            ref={(el) => {
                              if (el) {
                                propertyRefs.current[
                                  `${radioItem.item.id}-${label}`
                                ] = el;
                              }
                            }}
                          >
                            {radioItem.item[label] || "--"}
                          </p>
                        ) : label == "vendor_name" ? (
                          <p
                            className="light-font"
                            ref={(el) => {
                              if (el) {
                                propertyRefs.current[
                                  `${radioItem.item.id}-${label}`
                                ] = el;
                              }
                            }}
                          >
                            {radioItem.item.vendor_id} - {radioItem.item[label]}
                          </p>
                        ) : label == "score" ? (
                          <div className="score-container">
                            <i className="icon-favorite"> </i>
                            <p
                              className="light-font"
                              ref={(el) => {
                                if (el) {
                                  propertyRefs.current[
                                    `${radioItem.item.id}-${label}`
                                  ] = el;
                                }
                              }}
                            >
                              {radioItem.item[label] || "--"}
                            </p>
                          </div>
                        ) : (
                          <p
                            className="light-font"
                            ref={(el) => {
                              if (el) {
                                propertyRefs.current[
                                  `${radioItem.item.id}-${label}`
                                ] = el;
                              }
                            }}
                          >
                            {radioItem.item[label] || "--"}
                          </p>
                        )}
                      </Tooltip>
                    </div>
                  ))}
                  {!displayForm ? (
                    <Skeleton height={"1.5rem"} width={"100%"} />
                  ) : (
                    <Dropdowns
                      context={{
                        dropdownsData,
                        setDropdownsData,
                        setDropdownIds,
                        dropdownDefaultOptions,
                      }}
                      updateDropdown={updateDropdown}
                      resetDropdownsReload={resetDropdownsReload}
                      hideErrorLabel={true}
                      hideLabel={true}
                      required={true}
                      key={74}
                      onOptionSelect={(value, data) =>
                        handleDropdownValue(
                          value,
                          dropdownNames[74],
                          data,
                          radioItem.item
                        )
                      }
                      hideRequiredLabel={true}
                      showPagination={false}
                      data={dropdownsData.find((e) => e.id === 74)}
                      preSelectValue={radioItem.item.currency_id}
                    />
                  )}
                  {!displayForm ? (
                    <Skeleton height={"1.5rem"} width={"100%"} />
                  ) : (
                    <BasicDatePicker
                      style={{ gridColumn: "span 1" }}
                      label={""}
                      onChange={(newValue) => {
                        changeValueDate(
                          newValue,
                          "response_date",
                          radioItem.item
                        );
                      }}
                      hideErrorLabel={true}
                      disablePastDates={true}
                      isDateTime={false}
                      value={radioItem.item.response_date || "--"}
                      name="responseDate"
                    ></BasicDatePicker>
                  )}
                  {!displayForm ? (
                    <Skeleton height={"1.5rem"} width={"100%"} />
                  ) : (
                    <Input
                      name="lead_days"
                      required={true}
                      disableAutocomplete={true}
                      label={""}
                      onChange={(e) => changeValue(e, radioItem.item)}
                      hideErrorLabel={true}
                      placeholder={"--"}
                      isNumeric={true}
                      value={radioItem.item.lead_days || "--"}
                    />
                  )}
                  {!displayForm ? (
                    <Skeleton height={"1.5rem"} width={"100%"} />
                  ) : (
                    <Input
                      name="unit_cost"
                      required={true}
                      disableAutocomplete={true}
                      onChange={(e) => changeValue(e, radioItem.item)}
                      label={""}
                      hideErrorLabel={true}
                      isNumeric={true}
                      placeholder={"--"}
                      value={radioItem.item.unit_cost || "--"}
                    />
                  )}
                  {!displayForm ? (
                    <Skeleton height={"1.5rem"} width={"100%"} />
                  ) : (
                    <Input
                      name="sub_total"
                      required={true}
                      disableAutocomplete={true}
                      hideErrorLabel={true}
                      isNumeric={true}
                      label={""}
                      disabled={true}
                      placeholder={"--"}
                      value={radioItem.item.sub_total}
                    />
                  )}
                  {!displayForm ? (
                    <Skeleton height={"1.5rem"} width={"100%"} />
                  ) : (
                    <Input
                      name="discount_applied"
                      required={true}
                      disableAutocomplete={true}
                      onChange={(e) => changeValue(e, radioItem.item)}
                      hideErrorLabel={true}
                      isNumeric={true}
                      disabled={
                        !radioItem.item.sub_total ||
                        radioItem.item.sub_total <= 0
                      }
                      limit={radioItem.item.sub_total}
                      placeholder={"--"}
                      label={""}
                      value={radioItem.item.discount_applied || "--"}
                    />
                  )}
                  {!displayForm ? (
                    <Skeleton height={"1.5rem"} width={"100%"} />
                  ) : (
                    <Input
                      name="tax_included"
                      required={true}
                      disableAutocomplete={true}
                      onChange={(e) => changeValue(e, radioItem.item)}
                      hideErrorLabel={true}
                      isNumeric={true}
                      label={""}
                      placeholder={"--"}
                      value={radioItem.item.tax_included || "--"}
                    />
                  )}
                  {!displayForm ? (
                    <Skeleton height={"1.5rem"} width={"100%"} />
                  ) : (
                    <Input
                      name="total_cost_pn"
                      required={true}
                      disableAutocomplete={true}
                      hideErrorLabel={true}
                      isNumeric={true}
                      label={""}
                      disabled={true}
                      placeholder={"--"}
                      value={radioItem.item.total_cost_pn || "--"}
                    />
                  )}
                  <div className="tag-status-vendor">
                    <button
                      className="button-vendor-action"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        enableEdition(radioItem.item, false);
                      }}
                    >
                      <i className="icon-new-save"></i>
                    </button>

                    <Tag
                      style={{ width: "9vw" }}
                      tag={radioItem.item.status}
                      type={switchedTagsMapper[radioItem.item.status]}
                    ></Tag>
                  </div>
                </div>
              )
            }
          />
        )}
      </div>
    </div>
  );
};
